import { Reducer } from "redux";

import { ReferralSubmitResponse } from "../models/Api/AllPatientRecord";
import { ReferralSubmitDispatchTypes } from "../models/DispatchTypes/AllPatientRecord";
import { ReferralSubmitActionDispatchTypes } from "../constants/AllPatientRecord";

export const initialState: ReferralSubmitResponse = {
  loading: false,

  response: {
    isCompleted: null,
    referralStage: [],
  },
  error: null,
};

const ReferralIntakeSubmit: Reducer<
  ReferralSubmitResponse,
  ReferralSubmitDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReferralSubmitActionDispatchTypes.POST_REFERRAL_SUBMIT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReferralSubmitActionDispatchTypes.POST_REFERRAL_SUBMIT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReferralSubmitActionDispatchTypes.POST_REFERRAL_SUBMIT_ERROR: {
      return {
        ...state,
        error: action.response,
        loading: false,
      };
    }
    case ReferralSubmitActionDispatchTypes.POST_REFERRAL_SUBMIT_RESET: {
      return {
        ...initialState,
      };
    }
  }
  return state;
};

export default ReferralIntakeSubmit;
